export default "<body>\n  <app-nav-menu></app-nav-menu>\n  <router-outlet></router-outlet>\n  <app-alert></app-alert>\n</body>\n"